@use '../../scss/utility';

:host {
  display: inline;
  margin-inline-end: utility.wb-pixel-to-rem(32px);
}

a {
  @include utility.wb-text(
    's',
    (
      strong: false,
      responsive: false,
    )
  );
  color: var(--wb-grey-60);
  text-decoration: none;
}

a:hover {
  color: var(--wb-white);
}

a:focus-visible {
  outline: utility.wb-pixel-to-rem(1px) solid var(--wb-blue-45);
}
